export default __webpack_public_path__ + "static/media/aboutme.9eac9b92.png";